import React from "react";
import "./default.scss";

const DefaultTheme = () => <React.Fragment></React.Fragment>;

export default DefaultTheme;
